import React, { Component } from 'react';
import { Form, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import '../../expenses.less';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: this.props.dataSource,
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataSource: nextProps.dataSource,
    });
  }

  handleChange = (pagination, filters, sorter) => {
    this.props.onChange(pagination, filters, sorter);
  };

  columns = () => {
    const {
      dataSource: { pagination },
    } = this.state;
    const current = pagination.current || 1;
    const total = pagination.total || 0;
    let config = [
      {
        title: '编号',
        dataIndex: 'num',
        width: '3%',
        render: (text, record, index) => {
          return <span>{total - (current - 1) * 15 - index}</span>;
        },
      },
      {
        title: '流水编号',
        dataIndex: 'no',
        width: '10%',
        render: (text, record) => {
          return (
            <Link to={`/administrative/material/renewal/open/${record.uuid}`}>
              {text || '查看'}
            </Link>
          );
        },
      },
      {
        title: '资料名称',
        dataIndex: 'documentName',
        width: '10%',
        render: (text, record) => {
          return (
            <Link to={`/administrative/material/info/${record.documentUuid}`}>
              {text || '查看'}
            </Link>
          );
        },
      },
      {
        title: '申请人',
        width: '8%',
        dataIndex: 'createUserName',
        key: 'createUserName',
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: '10%',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '当前环节-处理人',
        dataIndex: 'name',
        key: 'name',
        width: '15%',
        render: (text, record) => {
          const instance = record.instance || {};
          const currentActivity = instance.currentActivity || {};
          const { name, processorName } = currentActivity;
          return <span>{currentActivity.uuid ? `${name || ''}-${processorName || ''}` : ''}</span>;
        },
      },
      {
        title: '完成时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        width: '15%',
        render: (text, record) => {
          const a = moment.unix(record.finishTime / 1000);
          const b = moment.unix(record.createTime / 1000);
          return (
            <span>
              {record.finishTime ? (
                <span>
                  {moment.unix(record.finishTime / 1000).format('YYYY-MM-DD')}
                  <span>(用时{a.diff(b, 'days')}天)</span>
                </span>
              ) : (
                ''
              )}
            </span>
          );
        },
      },
      {
        title: '状态',
        dataIndex: 'status',
        width: '8%',
        render: (text, record) => {
          record.status = record.status === 0 || record.status === 1 ? record.status : 2;
          if (record.status === 0) {
            return <span>审核中</span>;
          }
          if (record.status === 1) {
            return <span style={{ color: 'red' }}>已完成</span>;
          }
          return <span>待编辑</span>;
        },
      },
    ];
    if (this.props.type === 'mine') {
      config = config.filter(item => item.dataIndex !== 'createUserName');
    }
    return config;
  };

  render() {
    const {
      dataSource: { list, pagination },
    } = this.state;
    return (
      <Table
        loading={this.props.loading}
        columns={this.columns()}
        dataSource={list}
        pagination={pagination}
        rowKey="uuid"
        onChange={this.handleChange}
      />
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/administrative/material/renewal/TableExpenses.js